// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"theme_sectionTitle__k_Z27","page":"style_page__1IbE6 theme_page__1oxFh","mainTitle":"style_mainTitle__GN9Bj theme_sectionTitle__k_Z27"};